import i18n from '@/i18n';
import { taskAPI } from '@/utils/api';
import { assertVideoToolsAvailable } from '@/pages/ipe/workbench/constants/videoToolsMaintenance';
import { clearVideoTaskCancelled } from './videoTaskCancel';

/**
 * 视频生成任务重试：调用 restart-video，清空 agentVideoTaskId / 终态 phase 后重新提交。
 * 切勿只改 status=processing，否则 Worker pollOneTask 遇终态 phase 会直接 return。
 */
export async function retryVideoTask(task) {
  const maintenance = assertVideoToolsAvailable();
  if (!maintenance.ok) throw new Error(maintenance.message);
  const taskId = String(task?.id || '').trim();
  if (!taskId) throw new Error(i18n.t('workbench:ipeUtilError.taskInvalid'));
  clearVideoTaskCancelled(taskId);
  const updated = await taskAPI.restartVideo(taskId);
  return updated?.task || updated || null;
}
